module.exports = __webpack_public_path__ + "img/15.22b1274f.png";